m.connect({
    name: 'validation',
    __proto__: {
        showError: (field, message) => {
            let parent = field.parentNode;
            let name = field.name || field.dataset.name;
            let container = document.createElement('div');
            container.innerHTML = message;
            container.className = 'mb-error error-' + name;
            parent.appendChild(container);
        },
        hideError: field => {
            try {
                let parent = field.parentNode;
                let message = parent.querySelector('.error-' + field.name);
                parent.removeChild(message);
            } catch (e) {}
        },
    },
    fieldName : function (name) {
        this.hideError(name);

        if (!name.value) {
            this.showError(name,  m.trans.get('Name is required'));
            return false;
        }

        return true;
    },
    fullName: function(fullname) {
        this.hideError(fullname);

        if (!fullname.value) {
            this.showError(fullname,  m.trans.get('Full Name is required'));
            return false;
        } else if (fullname.value.length < 5 ) {
            this.showError(fullname,  m.trans.get('Enter at least 5 characters'));
            return false;
        }

        return true;
    },
    email: function(email) {
        const regEmail = /^\S+@\S+\.\S+$/;
        this.hideError(email);

        if (!email.value) {
            this.showError(email,  m.trans.get('Email is required'));
            return false;
        } else if (!email.value.match(regEmail)) {
            this.showError(email,  m.trans.get('Email is not valid'));
            return false;
        }

        return true;
    },
    phone: function(phone) {
        const regPhone = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
        this.hideError(phone);

        if (!phone.value) {
            this.showError(phone,  m.trans.get('Phone is required'));
            return false;
        } else if (!phone.value.match(regPhone)) {
            this.showError(phone,  m.trans.get('Please enter a valid phone number. Try to use format: +XX XXX XXX XXX'));
            return false;
        }

        return true;
    },
    subject: function(subject) {
        this.hideError(subject);

        if (!subject.value) {
            this.showError(subject,  m.trans.get('Subject is required'));
            return false;
        }

        return true;
    },
    message: function(message, limit) {
        this.hideError(message);

        if (message.value.length < limit) {
            this.showError(message,  m.trans.get('Enter at least ') + limit +  m.trans.get(' characters'));
            return false;
        }

        return true;
    }
});